import React, { Component } from 'react';
import { Link, browserHistory } from 'react-router';
import ReactStars from 'react-stars';
import $ from 'jquery';
import WebHeaderInner from './../Common/WebHeaderInner.js';
import WebFooter from './../Common/WebFooter.js';

import { ShareButtons, generateShareIcon } from 'react-share';
const {FacebookShareButton,GooglePlusShareButton,TwitterShareButton} = ShareButtons;
const FacebookIcon = generateShareIcon('facebook');
const TwitterIcon = generateShareIcon('twitter');
const GooglePlusIcon = generateShareIcon('google');
import { Panel } from 'react-bootstrap';
import InfiniteScroll from 'react-infinite-scroll-component';
const baseUrl='https://aquadeals.in/admin/web3/user/';
const baseAssets='https://aquadeals.in/admin/assets/';
// /web/stores/:StoreType/:ID

export default class Web_Store_Deals extends Component{
	constructor(props){
		super(props);
		this.state={
			store_deals:[],
			loading_more_status:false,
			
			brands: [],
			sort_list:[],
			feedcat: [],
		    nodata:false,
		    open: false,
		    types:[],
		    title:'',
		    desc:'',
		    tid : this.props.params.Tid,
		    type: this.props.params.Type,
		    dtype: this.props.params.DType,
		    htype: this.props.params.DType,
		    data_type: this.props.params.DType,
		    bread: '',
		    activeMenu: '',
		    selected: '',
		    loading: false,
		    lod: false,
		    loadmore_number: 2,
		    loadmore_status: 0,
		    set_type:'',
		    next_page:'',
		    seo_desc:'',
		    loading_gif:false,
		    h1_desc:'',
		    nav_deal_offers:[],

		    id:'',
		    Typ:'',
		 
		};
		this.getCartCount=this.getCartCount.bind(this);
		this.getSelectedStore=this.getSelectedStore.bind(this);
		this.refresh=this.refresh.bind(this);
		this.fetchData=this.fetchData.bind(this);
	}
	getSelectedStore(type,id)
	{
	    this.setState({
	    	loading_gif:true,
	    });
	    var uid =0;
	    if(localStorage.user_id)
	    {
	       uid=localStorage.getItem('user_id')
	    }
	    else
	    {
	        uid=0;
	    }
	    if(type ==='Ad guarantee')
		{
		  var type1='ad-guarantee';
		  var id1 ='';
		}
		else
		{
           type1 = 'store';
           id1 =id;
		}
	    var baseUrl='https://aquadeals.in/admin/web3/user/';
	    var data1={from: 'desktop_web',uid:uid,tid:id1,type:type1,dtype:'',bid:'',limit:20};
	    var data2=JSON.stringify(data1);
	    $.ajax({
	          method: 'POST',
	          url: baseUrl+'getProductbycat_brand',
	          dataType:'json',
	          data: {req:data2},
	          success: function(data)
	          {
		            if(data.result.length === 0)
	        		{
	        			this.setState({
	        				nodata:true,
	        			})
	        		}
	        		else
	        		{
	        			this.setState({
	        				nodata:false,
	        			});
	        		}
	        		if(data.status==="success")
	        		{
	        			this.setState({
	        				store_deals:data.result,

	        				page_name:data.cat_name,
	        				loading:true,
	                        title: data.product_name,
	                        desc:'The best offers of AquaDeals',
	                        selected  : data.cat_name,
	                        loadmore_status:data.load_more,
	                        set_type:data.set_type,
	                        next_page:data.next_page,
	                        // h1_desc:data.cat_name ? 'Shop the best deals from '+data.cat_name +' Store' : 'Shop the best deals from AquaDeals Store',
	                        loading_gif:false,
	        			});
	        			if(data.cat_name === 'CP Store')
	        			{
	        				this.setState({
	        					h1_desc:data.cat_name ? 'Shop the best deals from '+data.cat_name : 'Shop the best deals from AquaDeals Store'
	        				})
	        			}
	        			else
	        			{	
	        				this.setState({
	        					h1_desc:data.cat_name ? 'Shop the best deals from '+data.cat_name +' Store' : 'Shop the best deals from AquaDeals Store',	
	        				})
	        			}
	        		}
	          }.bind(this),
	          error: function(err)
	          {
	          }
	    });
	}
	
	componentDidMount()
	{
		window.scrollTo(0, 0);				
		if(screen.width < 800)
		{
			if(this.props.params.ID)
			{
				window.location.href="/stores/"+this.props.params.StoreType+'/'+this.props.params.ID;	
			}
			else
			{
				window.location.href="/stores/"+this.props.params.StoreType;
			}
			
		}
		if(localStorage.token && localStorage.user_id)
		{
			this.getCartCount();
		}
		var uid =0;
	    if(localStorage.user_id)
	    {
	       uid=localStorage.getItem('user_id');
	    }
	    else
	    {
	      uid=0;
	    }
	    var type='store';
		if(this.props.params.StoreType==='caa-approved')
		{
			type=this.props.params.StoreType;
		}
		else if(this.props.params.StoreType==='ad-guarantee')
		{
			type=this.props.params.StoreType;

		}
		else if(this.props.params.StoreType==='ad-assist')
		{
			type=this.props.params.StoreType;
		}
        this.setFilter(this.props.params.StoreType);
		this.navStoreTypes();
		var baseUrl='https://aquadeals.in/admin/web3/user/';
		var data1={from: 'desktop_web',uid:uid,tid:this.props.params.ID,type:type,dtype:'',bid:'',sort:'',limit:20};
		var data2=JSON.stringify(data1);
		$.ajax({
  	    	method: 'POST',
    		url: baseUrl+'getProductbycat_brand',
      		dataType:'json',
      		data: {req:data2},
      		success: function(data)
      		{
        		if(data.result.length === 0)
        		{
        			this.setState({
        				nodata:true,
        			})
        		}
        		else
        		{
        			this.setState({
        				nodata:false,
        			});
        		}
        		if(data.status==="success")
        		{
        			this.setState({
        				store_deals:data.result,

        				page_name:data.cat_name,
        				loading:true,
                        title: data.product_name,
                        desc:'The best offers of AquaDeals',
                        selected  : data.cat_name,
                        loadmore_status:data.load_more,
                        set_type:data.set_type,
                        next_page:data.next_page,
                        // h1_desc:data.cat_name ? 'Shop the best deals from '+data.cat_name +' Store' : 'Shop the best deals from AquaDeals Store',
        			});	
        		}
        		if(data.cat_name === 'CP Store')
    			{
    				this.setState({
    					h1_desc:data.cat_name ? 'Shop the best deals from '+data.cat_name : 'Shop the best deals from AquaDeals Store',
    				})
    			}
    			else
    			{	
    				this.setState({
    					h1_desc:data.cat_name ? 'Shop the best deals from '+data.cat_name +' Store' : 'Shop the best deals from AquaDeals Store',
    				})
    			}


        		// document.title =this.state.web_title+  " - Deals | AquaDeals ";
	            // document.getElementsByTagName("META")[2].content=this.state.seo_desc;
			}.bind(this),
  			error: function(err)
  			{
  				// console.log("Error"+err);
  			}
        });
	}
	
	getCartCount()
	{
	    var baseUrl='https://aquadeals.in/admin/web3/user/';
	    var data1={from: 'desktop_web',id:localStorage.getItem('user_id'),token:localStorage.getItem('token')};
	    var data2=JSON.stringify(data1);
	    $.ajax({
	          method: 'POST',
	          url: baseUrl+'cart_count',
	          dataType:'json',
	          data: {req:data2},
	          success: function(data)
	          {
	           	this.setState({
	                cart_count:data.cart_count,
	            });
	          }.bind(this),
	          error: function(err)
	          {
	          
	          }
	    });
	}
	
    fetchData()
    {
    	this.setState({
    		loading_gif:true,
			loading_more_status:true,
		});
        var getfunc="";
        var baseUrl='https://aquadeals.in/admin/web3/user/';
        var data1="";
        var data2="";
		var uid =0;
		if(localStorage.user_id)
		{
			uid=localStorage.getItem('user_id')
		}
		else
		{
			uid=0;
		}
		// this.state.next_page, this.state.set_type,this.props.params.Tid,this.props.params.DType
		var num=this.state.next_page;
		var dtype=this.props.params.DType;
		// var type=this.state.set_type;
		var tid=this.props.params.Tid;
        var type='store';
		if(this.props.params.StoreType==='caa-approved')
		{
			type=this.props.params.StoreType;
		}
		else if(this.props.params.StoreType==='ad-guarantee')
		{
			type=this.props.params.StoreType;
		}
		else if(this.props.params.StoreType==='ad-assist')
		{
			type=this.props.params.StoreType;
		}

        if(type==="all")
        {
          	data1={from :'desktop_web',page:num,type:dtype,limit:20};
          	data2=JSON.stringify(data1);
          	getfunc="getPoductDeals";
        }
        if(type==="Pcategory")
        {
	        data1={from: 'desktop_web',uid:uid,page:num,dtype:dtype, type:type, tid:tid,limit:20};
	        data2=JSON.stringify(data1);
	        getfunc="getProductbycat_brand";
        }
        if(type==="brand")
        {
         	data1={from:'desktop_web',uid:uid,page:num,dtype:dtype,type:type,tid:tid,limit:20};
          	data2=JSON.stringify(data1);
          	getfunc="getProductbycat_brand";
        }
        else
        {
          	data1={from:'desktop_web',uid:uid,page:num,dtype:dtype,type:type,tid:this.props.params.ID,limit:20};
          	data2=JSON.stringify(data1);
          	getfunc="getProductbycat_brand";	
        }
        
        var products="";
        if(this.state.loadmore_status===1)
      	{
	        $.ajax({
	              method: 'POST',
	              url: baseUrl+getfunc,
	              dataType:'json',
	              data: {req:data2},
	              success: function(data){
	                  this.setState({
	                  	// store_deals:data.result,
	                      loading:true,
	                      loading_more_status:false,
	                      title:data.cat_name,
	                      desc:data.cat_desc,
	                      selected  : data.cat_name,
	                      loadmore_status:data.load_more,
	                      set_type: data.set_type,
	                      next_page:data.next_page,
	                      loading_gif:false,
	                  });
	                this.setState({ 
	                    store_deals:this.state.store_deals.concat(data.result),
	                });
	              }.bind(this),
	              error:function(err){
	                // console.log(err);
	                this.setState({
	                	loading_gif:false,
	                	loading_more_status:false,
	                })
	              }
	          });
	    }
	    else
	    {
	    	this.setState({
	    		loading_gif:false,
	    	})
	    }
    }
    refresh()
    {
    	console.log("");
    }
    navStoreTypes()
    {
    	var baseUrl='https://aquadeals.in/admin/web3/user/';
        var data1={from:'desktop_web',};
	    var data2=JSON.stringify(data1);
	    $.ajax({
	            method:'post',
	            url:baseUrl+'getdealOffers_sidebar',
	            dataType:'json',
	            data: {req:data2},
	            success:function(data)
	            {
	              this.setState({
	                nav_deal_offers: data.deal_offers,
	              });
	            }.bind(this),
	            error:function(err)
	            {
	              // console.log(err);
	            }
	    });
    }
    setFilter(filter)
	{
	    this.setState({Typ:filter});
    }
	isActive(value)
	{
	  // var val = value.toUpperCase();
	  // console.log(val);	
	   return 'li '+((value ===this.state.Typ) ?'active':'');
	}
	render()
	{
		var nav_stores = this.state.nav_deal_offers.map(function(data,index){
                return(
                 // <li key={data.id} id={"brand_"+data.id}  /*className={this.isActive(data.type)} onClick={this.setFilter.bind(this,data.type)}*/ className={this.isActive(data.id)} onClick={this.setFilter.bind(this,data.id)}>
                 <li key={data.id} id={"brand_"+data.id}  className={this.isActive(data.url_storetype)} onClick={this.setFilter.bind(this,data.url_storetype)}>
                     <Link onClick={()=>{this.getSelectedStore(data.type,data.id)}}   to={parseInt(data.id,10) === 17 ? "/web/ad-banners/ad-guarantee" :"/web/stores/"+data.url_storetype+"/"+data.id}>
                        <span>{data.type}</span>
                     </Link>
                  </li>

                      );
                  }.bind(this));

		document.title=this.state.page_name ? 'Shop the best deals from '+this.state.page_name+ ' Store' : 'Shop the best deals from AquaDeals Stores';
		var storedeals = this.state.store_deals.map((deal, index) => (<Product key={index} data={deal}  onUpdate={()=>this.getCartCount()} /> ));
		return(
				<div className="web_deals web_pdeals_page">        
   		{this.state.loading ? <div className="lgt_gry">
                <WebHeaderInner/>
                <div className="clr">&nbsp;</div>
                <div className="clr">&nbsp;</div>
                <div className="clr">&nbsp;</div>
                <div className="clr">&nbsp;</div>
                <div className="clr">&nbsp;</div>
                <div className="clr">&nbsp;</div>
                <h1 className="page_title">{this.state.h1_desc}</h1>
                <div className="clr">&nbsp;</div>
                <section className="container Dels_cntnt" style={{paddingLeft:0}}>
                  <div className="tot_pro">
                    <div className="row">
                            <div className="col-md-3 col-sm-3">
                                <div className="filtrs_blk">
                                    <h3>Stores</h3>
                                    <ul>
                                    	{nav_stores}
                                    </ul>
                                </div>
                            </div>
							<div className="col-md-9 col-sm-9 pro_sec">
                               <div className="clr"></div>   
	                                <div className="row itm_lst">
	                                	{this.state.loading_gif ? <i className="web_loading_gif"><img src={'https://aquadeals.in/admin/assets/images/loading_more.gif'} alt="Loading" /></i> : ''}
	                                    {/*{storedeals ? storedeals : <div>{this.state.lod ? <div className="seed_no_data">No Deals Available</div> : <div className="loading_sym" style={{width:100+'%',textAlign:'center',marginTop:15+'%'}}><img src={require('./../../assets/images/ajax-loader.gif')} alt="AquaDeals" role="presentation" /></div> }</div> }*/}
	                                    <InfiniteScroll
	                                      pullDownToRefresh
	                                      pullDownToRefreshContent={
	                                        <h3 style={{textAlign: 'center'}}>&#8595;</h3>
	                                      }
	                                      releaseToRefreshContent={
	                                        <h3 style={{textAlign: 'center'}}>&#8593;</h3>
	                                      }
	                                      refreshFunction={this.refresh}
	                                      next={this.fetchData}
	                                      hasMore={true}
	                                      scrollThreshold={0.3}
	                                      loader={<h4></h4>}
	                                      endMessage={
	                                        <p style={{textAlign: 'center'}}>
	                                          <b></b>
	                                        </p>
	                                      }>
	                                      {storedeals}
	                                    </InfiniteScroll>
	                                </div> 
                                        {/*{this.state.loadmore_status === 1  ? <div className="web_loadmore_button" onClick={()=>{this.setState({ loadmore_number : this.state.loadmore_number+1 }); this.loadMoreDeals(this.state.next_page, this.state.set_type,this.props.params.Tid,this.props.params.DType)}}><i className="glyphicon glyphicon-circle-arrow-down"></i>Load More Deals</div> : ''}*/}
                                </div>
                             </div>
                         </div>
                    </section>
                <div className="clr"></div>
                <WebFooter />
</div> : <div className="loading_sym" style={{width:'100%',textAlign:'center',marginTop:'20%'}}><img src={'https://aquadeals.in/admin/assets/images/web_imgs/ajax-loader1.gif'} alt="Loading Deals" role="presentation" /></div>}</div>
        )			
	}
}

export class Product extends Component{
	constructor()
	{
	    super();
	    this.state={
		      open: false,
		      msg: '',
		      shareUrl: '',
		      cart_count:'',
		      clearcart_status:false,
		      already_added_status:false,
	    };
	    this.ShareFunc=this.ShareFunc.bind(this);
	    // this.addToCart=this.addToCart.bind(this);
	    this.updateCartCount=this.updateCartCount.bind(this);
	    this.close=this.close.bind(this);
	    this.replaceCartItems=this.replaceCartItems.bind(this);
	    // this.addToQuickCart=this.addToQuickCart.bind(this);
  	}
  	ShareFunc(evnt)
  	{
	    var baseUrl='https://aquadeals.in/admin/web3/user/';
	    var data1={from: 'desktop_web',type:1,did:evnt};
	    var data2=JSON.stringify(data1);
	    $.ajax({
	          method: 'POST',
	          url: baseUrl+'createTinyurl',
	          dataType:'json',
	          data: {req:data2},
	          success: function(data)
	          {
	            this.setState({
	                msg: data.msg,
	                shareUrl: data.tinyurl,
	            });
	          }.bind(this),
	          error: function(err)
	          {
	            
	          }
	    });
	    this.setState({
	      open: !this.state.open 
	    });
	    setTimeout(() => {this.setState({open: false}); }, 5000);
  	}
	replaceCartItems(deal_id,quantity)
  	{
	  	var baseUrl='https://aquadeals.in/admin/web3/user/';
	  	var data1={from: 'desktop_web',id:localStorage.getItem('user_id'),token:localStorage.getItem('token'),deal_id:deal_id,deal_type:1,quantity:quantity,pl_size:0,salinity:0,pickup_date:0}
		var data2=JSON.stringify(data1);
		$.ajax({
			method:'post',
			dataType:'json',
			url: baseUrl+'replaceCart',
			data:{req:data2},
			success:function(data)
			{
				console.log(data);
				if(data.status==="success")
				{
					this.setState({
						clearcart_status:false,
					});
					browserHistory.push('/web/mycart');
				}
			}.bind(this),
			error:function(err)
			{

			}
		});
	}
	close()
	{
	  	this.setState({
	  		clearcart_status:false,
	  		already_added_status:false,
	  	});
	}
	// addToCart(deal_id)
 //  	{
	//   	if(!localStorage.user_id && !localStorage.token)
	//   	{
	//   		browserHistory.push('/web/login');
	// 	}
	// 	else
	// 	{
	// 		var baseUrl='https://aquadeals.in/admin/web3/user/';
	// 	  	var data1={from: 'desktop_web',id:localStorage.getItem('user_id'),token:localStorage.getItem('token'),deal_id:deal_id,deal_type:1}
	// 		var data2=JSON.stringify(data1);
	// 		$.ajax({
	// 			method:'post',
	// 			dataType:'json',
	// 			url: baseUrl+'quickBuy',
	// 			data:{req:data2},
	// 			success:function(data)
	// 			{
	// 				if(data.status==="success")
	// 				{
	// 					this.updateCartCount();
	// 					browserHistory.push('/web/mycart');
	// 				}
	// 				else if(data.status==="error" && data.cart_flag===0)
	// 				{
	// 					this.setState({
	// 						clearcart_status: true,
	// 					});
	// 				}
	// 				else if(data.status==="error" && data.message==="Product already added to the cart")
	// 				{
	// 					this.setState({
	// 						already_added_status: true,
	// 					});
	// 				}
	// 			}.bind(this),
	// 			error:function(err)
	// 			{

	// 			}
	// 		});
	// 	}
 //  	}
 //  	addToQuickCart(deal_id)
 //  	{
	//   	if(!localStorage.user_id && !localStorage.token)
	//   	{
	//   		browserHistory.push('/web/login');
	// 	}
	// 	else
	// 	{
	// 		var baseUrl='https://aquadeals.in/admin/web3/user/';
	// 	  	var data1={from: 'desktop_web',id:localStorage.getItem('user_id'),token:localStorage.getItem('token'),deal_id:deal_id,deal_type:1}
	// 		var data2=JSON.stringify(data1);
	// 		$.ajax({
	// 			method:'post',
	// 			dataType:'json',
	// 			url: baseUrl+'addToQCart',
	// 			data:{req:data2},
	// 			success:function(data)
	// 			{
	// 				if(data.status==="success")
	// 				{
	// 					this.updateCartCount();
	// 					browserHistory.push('/web/quickcart');
	// 				}
	// 				else if(data.status==="error" && data.cart_flag===0)
	// 				{
	// 					this.setState({
	// 						clearcart_status: true,
	// 					});
	// 				}
	// 				else if(data.status==="error" && data.message==="Product already added to the cart")
	// 				{
	// 					this.setState({
	// 						already_added_status: true,
	// 					});
	// 				}
	// 			}.bind(this),
	// 			error:function(err)
	// 			{

	// 			}
	// 		});
	// 	}
	// }
	updateCartCount()
	{
	  	this.props.onUpdate();
	}
	render()
	{
		var product=this.props.data;
		var shareUrl = this.state.shareUrl;
	    var title = "Hey Click here "+ shareUrl+ " to check "+ product.title + " from AquaDeals.";
	    var description = shareUrl;
		return(
			<div className="col-md-3 col-sm-6">
			   <div className="prdt_blk">
		          {product.dealcount >= 2 ? 
		            <div>
		                {product.ad_guarantee_flag === '1' ? <span className="web_ad_guarantee"><img src={baseAssets+'images/product_imgs/ad_guarantee.png'} alt="presentation"/></span> : ''}
                        <Link to={"/web/subdeals/"+product.url_dtype_name+"/"+product.url_cat_name+"/"+product.dtype+"/"+product.url_brand_name+"/"+product.pid} >
		                  	{product.promo_ribbion ? <i className="ribbon_img"><img src={'https://aquadeals.in/admin/assets/images/web_imgs/'+product.promo_ribbion} alt="" /></i> : ''}
		                    <div >
		                        <img  alt=" " src={product.image !==null && product.image !=='' ? 'https://aquadeals.in/admin/assets/images/product_imgs/thumbnails/'+product.image : 'https://aquadeals.in/admin/assets/icons/web_icons/noImage.png'} />
		                    </div>
		                    {product.title ? <h3>{product.title} {product.quantity}</h3> : <h3>&nbsp;</h3>}
		                    {product.brand_name ? <h4>{product.brand_name}</h4> : <h4>&nbsp;</h4>}
		                    {product.dealcount >=2 ? <h4>{product.dealcount} deals available</h4> : <h4>&nbsp;</h4>}
		                 </Link> 
		                  <div className="row stars_view_blk">   
		                    <div className="clr"></div>
		                    <div className="col-md-7 col-xs-7" style={{paddingRight:'0'}}>
                              <div className="prdt_str_rt">
		                         <ReactStars
		                              count={5}
		                              className={'webRate_blk_item'}
		                              size={17}
		                              value={product.over_rate >=1 ? product.over_rate : 0}
		                              edit={false}
		                              color1={'#ccc'}
		                              color2={'#ffc50a'} />
		                      </div>
		                    </div>
		                    <div className="col-md-5 col-xs-5" style={{paddingLeft:0}}>
                                {product.count > 0 ? <span className="prdt_views"><i><img src={baseAssets+'images/web_imgs/eye.png'} alt=""/></i> {product.count}</span> : <span className="prdt_views hide_views"><i><img src={baseAssets+'images/web_imgs/eye.png'} alt=""/></i> 0</span>}
                            </div>  
		                  </div>
		                {/*<Link className="share_btn" onClick={()=>{this.ShareFunc(product.deal_id)}}>
		                    <img src={require('./../../../assets/images/share.png')} alt="Share" />
		                </Link>
		                <Panel className="share_panel" collapsible expanded={this.state.open}>
		                    <FacebookShareButton url={shareUrl} quote={title} className="test_share">
		                      <FacebookIcon size={32} round />
		                    </FacebookShareButton>
		                    <TwitterShareButton url={shareUrl} quote={title} className="test_share">
		                      <TwitterIcon size={32} round />
		                    </TwitterShareButton>
		                    <GooglePlusShareButton url={shareUrl} quote={title} description={description} className="test_share">
		                      <GooglePlusIcon  size={32} round />
		                    </GooglePlusShareButton>
		                </Panel>*/}
		                 <div className="clr"></div>
		            </div> : 
		            <div>
		            	 {product.ad_guarantee_flag === '1' ? <span className="web_ad_guarantee"><img src={baseAssets+'images/product_imgs/ad_guarantee.png'} alt="presentation"/></span> : ''}
                        <Link className="lst_share_btn" onClick={()=>{this.ShareFunc(product.deal_id)}}>
		                    <img src={'https://aquadeals.in/admin/assets/images/web_imgs/share.png'} alt="Share" />
		                </Link>
		                <Panel className="share_panel" collapsible expanded={this.state.open}>
		                    <FacebookShareButton url={shareUrl} quote={title} className="test_share">
		                      <FacebookIcon size={32} round />
		                    </FacebookShareButton>
		                    <TwitterShareButton url={shareUrl} quote={title} className="test_share">
		                      <TwitterIcon size={32} round />
		                    </TwitterShareButton>
		                    <GooglePlusShareButton url={shareUrl} quote={title} description={description} className="test_share">
		                      <GooglePlusIcon  size={32} round />
		                    </GooglePlusShareButton>
		                </Panel>
		                <Link key={product.pid} className='cursor' to={"/web/pdetails/"+product.url_dtype_name+"/"+product.url_cat_name+"/"+product.url_brand_name+"/"+product.url_product_name+"/"+product.pid+"/"+product.deal_id} >
		                	{product.promo_ribbion ? <i className="ribbon_img"><img src={'https://aquadeals.in/admin/assets/images/web_imgs/'+product.promo_ribbion} alt="" /></i> : ''}
		                    <div>
		                        <img alt=" " src={product.image !==null && product.image !=='' ? 'https://aquadeals.in/admin/assets/images/product_imgs/thumbnails/'+product.image : 'https://aquadeals.in/admin/assets/icons/web_icons/noImage.png'}/>
		                    </div>
		                    {product.title ? <h3>{product.title} {product.quantity}</h3> : <h3>&nbsp;</h3>}
		                    {product.brand_name ? <h4>{product.brand_name}</h4> :<h4>&nbsp;</h4>}
		                    {product.pricediff ? <h4><span>AquaCash Discount</span>&nbsp;<span>&#8377;{product.pricediff}</span></h4> : ''}
		                    {product.pricediff ==="" ? <h4>MRP &#8377; {product.mrp}</h4> : ''}
		                </Link>    
		                <div className="row stars_view_blk">   
		                  <div className="clr"></div>
		                    <div className="col-md-7 col-xs-7" style={{paddingRight:'0'}}>
                              <div className="prdt_str_rt">
		                         <ReactStars
		                              count={5}
		                              className={'webRate_blk_item'}
		                              size={17}
		                              value={product.over_rate >=1 ? product.over_rate : 0}
		                              edit={false}
		                              color1={'#ccc'}
		                              color2={'#ffc50a'} />
		                      </div>
		                    </div>
		                    <div className="col-md-5 col-xs-5" style={{paddingLeft:0}}>
                                {product.count > 0 ?  <span className="prdt_views"><i><img src={baseAssets+'images/web_imgs/eye.png'} alt=""/></i> {product.count}</span>: <span className="prdt_views hide_views"><i><img src={baseAssets+'images/web_imgs/eye.png'} alt=""/></i> 0</span>}
                            </div>  
		                </div>
                        <div className="clr"></div>
		            </div>}
                </div>
			</div>
		)
	}
}



/** WEBPACK FOOTER **
 ** ./src/Desktop/components/Stores/Web_Store_Deals.js
 **/